document.addEventListener('DOMContentLoaded', function () {

    // Script to handle the burger button toggle
    document.getElementById('burger-button').addEventListener('click', function () {

        const burgerButton = document.getElementById('burger-button');
        const mobileMenu = document.querySelector('#mobile-head .header-nav');

        // Toggle the burger button between burger and X
        burgerButton.classList.toggle('open');

        // Force a reflow to ensure the height is calculated
        if (!mobileMenu.classList.contains('show')) {
            mobileMenu.style.height = mobileMenu.scrollHeight + 'px'; // Set the height to content's height
            mobileMenu.offsetHeight; // This forces the browser to reflow and apply the height
            mobileMenu.classList.add('show');
        } else {
            mobileMenu.style.height = 0; // Collapse the menu
            mobileMenu.classList.remove('show');
        }
    });

    const carousels = document.querySelectorAll('.casino-carousel');
    carousels.forEach((carousel) => {
        new Glide(carousel, {
            type: 'carousel',
            perView: 4,
            gap: 10,
            startAt: 0.1, // Start at the second slide (0-based index)
            breakpoints: {
                992: {
                    perView: 3.1, // Adjust perView for screens <= 768px
                    gap: 8      // Optional: Adjust gap for this breakpoint
                },
                768: {
                    perView: 2.2, // Adjust perView for screens <= 768px
                    gap: 8      // Optional: Adjust gap for this breakpoint
                },
                480: {
                    perView: 1.3, // Adjust perView for screens <= 380px
                    gap: 5      // Optional: Adjust gap for this breakpoint
                }
            }
        }).mount();
    });

});